/**
 * ApprovalsDrawer - the global Approvals drawer shell (Story #5351 W1-T17,
 * Screen Contract G05: "Header Approvals control → persistent right
 * drawer"). URL-driven the same way as JobsDrawer (G04) and AlertsDrawer
 * (G06): `?approvals=1` opens it, so a deep link/reload/handed-off link all
 * land on the same open/closed state.
 *
 * Wraps the existing ApprovalsPanel (W1-T11) in the shared Drawer primitive
 * — this file owns only the URL-driven shell and does not duplicate
 * ApprovalsPanel's own honesty rules (no live backend: see that file's own
 * doc comment). `fixtureMode` stays false here (the default) — this is the
 * live-mode mount; /dev/fixtures (W1-T18) is the only fixtureMode=true
 * caller.
 */
import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { X } from 'lucide-react';
import Drawer from '../ui/Drawer';
import ApprovalsPanel from './ApprovalsPanel';
import { isW1Shell } from '../../utils/w1Flag';

const APPROVALS_PARAM = 'approvals';

const ApprovalsDrawer: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const flagOn = isW1Shell();
  const isOpen = searchParams.get(APPROVALS_PARAM) === '1';

  if (!flagOn || !isOpen) return null;

  const onClose = () => {
    const next = new URLSearchParams(searchParams);
    next.delete(APPROVALS_PARAM);
    setSearchParams(next);
  };

  return (
    <Drawer onClose={onClose} ariaLabel="Approvals" maxWidthClassName="max-w-lg" panelClassName="bg-white">
      <div className="flex items-center justify-end px-4 py-1 border-b border-gray-200 bg-white flex-shrink-0">
        <button
          type="button"
          onClick={onClose}
          aria-label="Close approvals"
          className="p-1 rounded hover:bg-gray-100 text-gray-500"
        >
          <X className="w-4 h-4" aria-hidden="true" />
        </button>
      </div>
      <ApprovalsPanel />
    </Drawer>
  );
};

export default ApprovalsDrawer;
